import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  // Validate scope is a valid option
  const validScopes = ['workflow', 'all'];
  if (properties.scope && !validScopes.includes(properties.scope)) {
    errors.push({ key: 'scope', message: 'Invalid scope value' });
  }

  // Validate error types are valid if provided
  const validErrorTypes = ['nodeError', 'timeout', 'validation', 'connection', 'authentication'];
  if (properties.errorTypes && Array.isArray(properties.errorTypes)) {
    properties.errorTypes.forEach((errorType: string) => {
      if (!validErrorTypes.includes(errorType)) {
        errors.push({ key: 'errorTypes', message: `Invalid error type: ${errorType}` });
      }
    });
  }

  return {
    valid: errors.length === 0,
    errors
  };
}
